package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.SubscriptionRepository
import com.clany.backoffice.model.UpdateSubscriptionPlanRequest
import dev.zacsweers.metro.Inject

class UpdateSubscriptionUseCase @Inject constructor(
    private val repository: SubscriptionRepository
) {
    suspend operator fun invoke(id: String, plan: String, status: String): Result<Unit> =
        repository.updatePlan(id, UpdateSubscriptionPlanRequest(plan, status))
}
